export const CloseBtnSvg = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FEFDFE" d="M.667 5.11 5.11.668l22.222 22.222-4.444 4.444z" />
    <path fill="#FEFDFE" d="M5.11 27.334.668 22.89 22.889.667l4.444 4.444z" />
  </svg>
);
